import React from 'react';
import {Icon, Header, Message} from 'semantic-ui-react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ContentDispatch} from 'framework';
import ApiActions from 'go/actions/api';

export class RequestDetailsListWrapper extends React.Component {
  handlePostSave = (entityTypeReduxPath) => {
    const {resType, resContext, entityIdPath, context} = this.props;
    if (entityTypeReduxPath) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, 3000);
      }).then((res) => {
        let token = context.auth.token;
        const awardRecEntityId = _.get(context, entityIdPath);
        let entityIds = [];
        if (
          this.props.includeAwardDataForComputation &&
          this.props.includeAwardDataForComputation === 'true'
        ) {
          entityIds = _.map(
            this.props.filteredSubAwardsAndAmendments,
            (record) => record.entityId
          );
        } else {
          entityIds = _.map(this.props.data, (record) => record.entityId);
        }
        let payload = {
          subAwardRecommendationIds: entityIds,
        };
        if (awardRecEntityId && entityIds.length > 0) {
          let p = this.props.updateAwardRecommendationByGrant(
            token,
            awardRecEntityId,
            JSON.stringify(payload)
          );
          p.then((res) => {
            if (res.type === resType) {
              this.props.saveEntitySessionData(resContext, res.payload);
            }
          });
        }
      });
    }
  };

  render() {
    const {
      contents,
      entityDataPath,
      data,
      guidance,
      headerName,
      allowApplicationTypes,
      infoMessage,
      previousRequestDetails,
    } = this.props;

    const noAppsToDisplay =
      _.filter(data, (subAward) =>
        _.includes(allowApplicationTypes, subAward.payload.applicationType)
      ).length == 0;

    return (
      <>
        {noAppsToDisplay && infoMessage ? (
          <>
            <Message info icon>
              <Icon name="info circle" size="large" className="infoIcon" />
              <Message.Content>{infoMessage}</Message.Content>
            </Message>
          </>
        ) : (
          <>
            <Header id={headerName} as={'h2'}>
              {headerName}
            </Header>
            <p className="margin-bottom30">{guidance}</p>
            {_.map(data, (dataEntry, fsIndex) => {
              return allowApplicationTypes.includes(dataEntry.payload.applicationType) ? (
                _.map(contents, (entry, index) => {
                  let props = {};
                  if (entry.type === 'CostShare' || entry.type === 'CostShareV2' ) {
                    props.dependencies = [
                      {
                        fundingStreamDataPath: `${entityDataPath}.${fsIndex}.payload.fundingStreams`,
                      },
                    ];
                    props.entityDataPath = `${entityDataPath}.${fsIndex}.payload.budget`;
                    props.validationErrorPath = `${entry.validationId}.0.${fsIndex}`;
                  }

                  if (entry.type === 'SubAwardRecommendationListener' ) {
                    props.dependencies = [
                      ...entry.dependencies,
                      {
                        fundingStreamsData: `${entityDataPath}.${fsIndex}.payload.fundingStreams`,
                      },
                    ];
                  }
                  return (
                    <ContentDispatch
                      config={entry}
                      key={entry.title}
                      entityDataPathIndx={fsIndex}
                      entityTypeReduxPath={`${entityDataPath}.${fsIndex}`}
                      handlePostSave={this.handlePostSave}
                      entityDataPath1={`${entityDataPath}.${fsIndex}.payload.fundingStreams`}
                      saveTotalDataPath={`${entityDataPath}.${fsIndex}.payload.budget.totalAmount`}
                      saveFedShareDataPath={`${entityDataPath}.${fsIndex}.payload.budget.share.fedShare`}
                      saveAppShareDataPath={`${entityDataPath}.${fsIndex}.payload.budget.share.appShare`}
                      isRfiActive={_.get(dataEntry, `isRfiActive`)}
                      fedShareRate={_.get(dataEntry, `payload.budget.share.fedRate`)}
                      appShareRate={_.get(dataEntry, `payload.budget.share.appRate`)}
                      applicationType={_.get(dataEntry, `payload.applicationType`)}
                      configType={'pc'}
                      configId={_.get(dataEntry, `categoryId`)}
                      ruleSet={'eligibility'}
                      entityType={_.get(dataEntry, `entityType`)}
                      construction={_.get(dataEntry, `payload.scopeOfWork.construction`)}
                      skipOverrideTotal={true}
                      hasEligibleChildren={false}
                      modeName={dataEntry.subGrantId}
                      subGrantId={dataEntry.subGrantId}
                      dataObject={dataEntry}
                      costShareIndex={fsIndex}
                      editable={!dataEntry.isRfiActive && !dataEntry.isBeingDeleted}
                      readOnly={
                        entry.readOnly ||
                        dataEntry.isRfiActive ||
                        dataEntry.isBeingDeleted
                      }
                      {...props}
                    />
                  );
                })
              ) : (
                <> </>
              );
            })}
          </>
        )}
      </>
    );
  }
}
export const mapDispatchToProps = (dispatch) => ({
  updateAwardRecommendationByGrant: (token, grantId, entityIds) => {
    const action = ApiActions.awardRecommendation.updateAwardRecommendationByGrant(
      token,
      grantId,
      entityIds
    );
    const res = dispatch(action);
    return res;
  },
});

export default connect(
  null,
  mapDispatchToProps
)(connectDynamic(RequestDetailsListWrapper));
